import { Landmark, Moon, Sun } from "lucide-react";
import { scrollToId, IG_HANDLE } from "../config";

export const Footer = ({ dark, onToggle }) => (
  <footer data-testid="footer-section" className="border-t border-line bg-surfacewarm transition-colors duration-500">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 py-16">
      <div className="grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-2.5">
            <span className="grid place-items-center w-10 h-10 rounded-full bg-forest text-bg">
              <Landmark size={18} />
            </span>
            <span>
              <span className="block font-serif font-bold text-lg leading-tight">Mulyono M.H.</span>
              <span className="block font-mono text-[10px] uppercase tracking-[0.2em] text-soft">
                Kades Cianjay · Kecamatan Cianjir
              </span>
            </span>
          </div>
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-soft">
            Balai Desa Cianjay — rumah kita bersama. Hadir, mendengar, dan bergerak untuk setiap warga,
            dari terbit fajar hingga lelap malam.
          </p>
          <p className="mt-4 font-mono text-xs text-soft">{IG_HANDLE}</p>
        </div>

        <div className="md:col-span-3">
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-soft mb-4">Jelajah</p>
          <ul className="space-y-2.5">
            {[
              ["profil", "Profil Singkat"],
              ["kerja-nyata", "Kerja Nyata"],
              ["dusun", "Galeri Dusun"],
              ["ronda", "Jaga Malam 24/7"],
              ["suara", "Suara Warga"],
              ["agenda", "Agenda Desa"],
              ["aspirasi", "Pojok Aspirasi"],
            ].map(([id, label]) => (
              <li key={id}>
                <button
                  data-testid={`footer-link-${id}`}
                  onClick={() => scrollToId(id)}
                  className="text-sm text-ink/80 hover:text-terra transition-colors"
                >
                  {label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-soft mb-4">Kenyamanan Membaca</p>
          <button
            data-testid="footer-darkmode-toggle"
            onClick={onToggle}
            className="inline-flex items-center gap-3 rounded-full border-2 border-line bg-surface px-5 py-3 text-sm font-semibold transition-all hover:border-terra hover:-translate-y-0.5"
          >
            <span className={`grid place-items-center w-8 h-8 rounded-full transition-colors ${dark ? "bg-amber2 text-night" : "bg-forest text-bg"}`}>
              {dark ? <Sun size={15} /> : <Moon size={15} />}
            </span>
            {dark ? "Matikan Mode Gelap" : "Nyalakan Mode Gelap"}
          </button>
          <p className="mt-3 text-xs text-soft">Untuk kenyamanan scroll malam hari.</p>
        </div>
      </div>

      <div className="mt-14 pt-7 border-t border-line flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-xs text-soft">© 2026 Mulyono M.H. — Kepala Desa Cianjay. Dibangun dengan semangat gotong royong.</p>
        <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-soft">Cianjay · Kekinian · Merakyat</p>
      </div>
    </div>
  </footer>
);
